import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { pdfService } from "../services/PdfService";
import { GrDocumentPdf } from "react-icons/gr";


function DownloadBoletoDialog({close,data}){

    return(
        <Dialog
        visible
        //showHeader={false}
        onHide={()=>close()}
        style={{
            minHeigth:'30vw', 
            minWidth: '20vw', 
            textAlign: 'center', 
            borderRadius: "0.75rem",
            fontFamily:'Branding-Bold'
        }}
        >
            <div className="negotiationButton p-[2vw] text-center font-bold text-slate-700 font-branding">
                <h5>O seu boleto foi gerado e já está pronto para pagamento</h5>
                <div className="flex p-[1vh] justify-center">
                    <i className="text-6xl"><GrDocumentPdf></GrDocumentPdf></i>
                </div>
                <div className="mt-[4vh]">
                    <Button 
                    label="Baixar Boleto"
                    onClick={()=>{pdfService(data)}}
                    >                
                    </Button>
                </div>
            </div>
        </Dialog>
        )
}

export default DownloadBoletoDialog